import PaisService from "@/services/PaisService";

export const pais = {
  namespaced: true,
  state: {
    pais: {},
  },
  actions: {
    getPaisOData({ commit }, payload) {
      return PaisService.GetPaisOData(payload).then(
        (pais) => {
          return Promise.resolve(pais);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pais;
